import httpAuth from '@/services/httpAuth'

export async function buscarClientes (txtpesquisa) {
  // console.log(txtpesquisa)
  return httpAuth.post('/crm/buscarclientes', txtpesquisa)
}

export async function buscarProdutos (cliente) {
  // console.log(cliente)
  return httpAuth.post('/crm/buscarprodutos', cliente)
}

export async function enviarPedido (obj) {
  // console.log(obj)
  return httpAuth.post('/crm/enviarpedido', obj)
}
